import "./finishOrderButton.scss";

function FinishOrderButton({ finishOrder }) {
  return (
    <div className="confirm-button mt-2">
      <button onClick={finishOrder} type="submit" className="w-100 text-center">
        Alugar brinquedos
      </button>
    </div>
  );
}

export default FinishOrderButton;
